import { Injectable, Injector } from '@angular/core';

import { Observable, of, Subject, merge } from 'rxjs';
import { HttpService } from 'projects/core/src/public-api';
import { Any } from 'json2typescript';
import { WsService } from '../../data/ws.service';
import { AppStateQuery } from 'projects/desktop/src/app/data/app-state.query';
import { FinishingVendor } from './finish-vendor';


@Injectable({
    providedIn: 'root',
})
export class FinishingVendorService extends HttpService {

    constructor(
        protected injector: Injector,
        protected appStateQuery: AppStateQuery,
        protected wsService: WsService
    ) {
        super(injector);
    }

    // createCustomer(): Observable<Customer> {
    // 	return this.postData(`/customer/create`, {active: true}, Customer);
    // }

    getCustomer(customerId: number): Observable<FinishingVendor> {
        return this.getData(`/customer/${customerId}`, FinishingVendor);
    }

    getVendors(): Observable<FinishingVendor[]> {
        return this.getData(`/finishing-vendor/list`, FinishingVendor)
    }


}